import {
  getFAQItems,
  getResourceMetaMap,
  getResourceSegments,
  getResourceUiI18n
} from "./podcastHelpers";

export const stripNextStepsFaqSystemFields = (data) => {
  const { createdAt, updatedAt, ...rest } = data || {};
  return rest;
};

export const buildResetNextStepsAudioMetadata = (resetAt = new Date().toISOString()) => ({
  hasUploadedAudio: false,
  objectPath: "",
  downloadUrl: "",
  contentType: "",
  fileName: "",
  uploadedAt: "",
  resetAt
});

export const buildUploadedNextStepsAudioMetadata = ({
  objectPath,
  downloadUrl,
  contentType,
  fileName,
  uploadedAt = new Date().toISOString()
}) => ({
  hasUploadedAudio: true,
  objectPath: String(objectPath || ""),
  downloadUrl: String(downloadUrl || ""),
  contentType: String(contentType || ""),
  fileName: String(fileName || "next-steps.mp3"),
  uploadedAt
});

export const buildDefaultNextStepsFaqConfig = (langCodeRaw = "EN") => {
  const langCode = String(langCodeRaw || "EN").toUpperCase();
  const segments = getResourceSegments(langCode);
  const meta = getResourceMetaMap(langCode);

  return {
    nextSteps: segments.map((seg) => ({
      key: seg.key,
      start: seg.start,
      end: seg.end,
      title: meta?.[seg.key]?.title || "",
      subtitle: meta?.[seg.key]?.subtitle || "",
      href: meta?.[seg.key]?.href || "",
      howTo: Array.isArray(meta?.[seg.key]?.howTo) ? meta[seg.key].howTo : []
    })),
    audioMetadata: buildResetNextStepsAudioMetadata(""),
    resourceUI: getResourceUiI18n(langCode),
    faqItems: getFAQItems(langCode)
  };
};

export const getCustomNextStepsArray = (config) =>
  Array.isArray(config?.nextSteps) ? config.nextSteps : null;

export const buildSegmentsFromNextSteps = (nextSteps) =>
  nextSteps
    .map((step) => ({
      key: String(step?.key || "").trim(),
      start: Number(step?.start),
      end: Number(step?.end)
    }))
    .filter((step) => step.key);

export const buildMetaFromNextSteps = (nextSteps) => {
  const meta = {};
  nextSteps.forEach((step) => {
    const key = String(step?.key || "").trim();
    if (!key) return;
    meta[key] = {
      title: String(step?.title || key),
      subtitle: String(step?.subtitle || ""),
      href: String(step?.href || ""),
      howTo: Array.isArray(step?.howTo) ? step.howTo : []
    };
  });
  return meta;
};

export const getDefaultNextStepsAudioPath = (langCodeRaw = "EN") => {
  const langCode = String(langCodeRaw || "EN").toUpperCase();
  if (langCode === "MN") return "Podcast media/Next_steps_MN.mp3";
  if (langCode === "ES") return "Podcast media/Next_steps_ES.m4a";
  return "Podcast media/Next_steps_EN.mp3";
};

export const resolveNextStepsRuntimeConfig = ({ config, selectedLanguage }) => {
  const langCode = String(selectedLanguage || "EN").toUpperCase();
  const nextSteps = getCustomNextStepsArray(config);

  const resourceSegments = nextSteps
    ? buildSegmentsFromNextSteps(nextSteps)
    : Array.isArray(config?.resourceSegments)
    ? config.resourceSegments
    : getResourceSegments(langCode);

  const resourceMeta = nextSteps
    ? buildMetaFromNextSteps(nextSteps)
    : config?.resourceMeta && typeof config.resourceMeta === "object" && !Array.isArray(config.resourceMeta)
    ? config.resourceMeta
    : getResourceMetaMap(langCode);

  const defaultResourceUI = getResourceUiI18n(langCode);
  const resourceUI =
    config?.resourceUI && typeof config.resourceUI === "object" && !Array.isArray(config.resourceUI)
      ? { ...defaultResourceUI, ...config.resourceUI }
      : defaultResourceUI;

  const faqList = Array.isArray(config?.faqItems) ? config.faqItems : getFAQItems(langCode);

  return {
    resourceSegments,
    resourceMeta,
    resourceUI,
    faqList
  };
};
